export default __webpack_public_path__ + "f85ce7f8164c23858481eecc542cd787.png";